import { firebaseApp } from "./firebase";
import { getStorage } from 'firebase/storage';

export const firebaseStorage = getStorage(firebaseApp);